import { Chip } from '@mui/material';
import { MeetingStatus } from 'gql/index';
import { useIntl } from 'react-intl';
import { MeetingStatusType, MeetingStatusTypeColor } from '../types';

export const MeetingStatusChip = (props: { status: MeetingStatus }) => {
  const { formatMessage } = useIntl();
  return <Chip label={formatMessage(MeetingStatusType[props.status])} color={MeetingStatusTypeColor[props.status]} size='small' />;
};